import axios from "axios";
import { endPoints } from "../constant/Environment";

// Keep this value outside Redux so the Axios interceptor can use it without a
// store import (which would create a circular dependency during app startup).
let currentUserId = null;

export const setApiErrorLogUserId = (userId) => {
  currentUserId = userId || null;
};

const ERROR_LOG_ENDPOINT ="errorlog/create";

const isErrorLogRequest = (url) =>
  typeof url === "string" && url.includes(ERROR_LOG_ENDPOINT);

const errorDetails = (error) => {
  const status = error?.response?.status;

  if (status === 404) {
    return { errorCode: "404", errorType: "NOT_FOUND" };
  }

  if (status === 502) {
    return { errorCode: "502", errorType: "BAD_GATEWAY" };
  }

  if (status >= 500) {
    return { errorCode: String(status), errorType: "SERVER_ERROR" };
  }

  if (error?.code === "ECONNABORTED" || /timeout/i.test(error?.message || "")) {
    return { errorCode: "TIMEOUT", errorType: "TIMEOUT" };
  }

  if (error?.request && !error?.response) {
    return { errorCode: "NOT_REACHABLE", errorType: "NOT_REACHABLE" };
  }

  return null;
};

/**
 * Records only the API failures that need operational follow-up. This uses a
 * plain Axios call, rather than axiosInstance, so an unavailable log endpoint
 * can never recursively create more error logs.
 */
export const traceApiError = (error) => {
  const details = errorDetails(error);
  const request = error?.config;

  if (!details || !request || request.__skipErrorLog || isErrorLogRequest(request.url)) {
    return;
  }

  const method = (request.method || "GET").toUpperCase();
  const target = request.baseURL
    ? `${request.baseURL.replace(/\/$/, "")}/${String(request.url || "").replace(/^\//, "")}`
    : request.url || "unknown endpoint";

  const payload = {
    userId: currentUserId,
    errorCode: details.errorCode,
    errorType: details.errorType,
    errorMessage: `${method} ${target}: ${error?.message || "Request failed"}`.slice(0, 2000),
  };

  // Fire-and-forget: logging must not delay or replace the original API error.
  axios
    .post(`${endPoints.apiBaseUrl.replace(/\/$/, "")}/${ERROR_LOG_ENDPOINT}`, payload, {
      timeout: 3000,
      headers: { "Content-Type": "application/json" },
      __skipErrorLog: true,
    })
    .catch(() => {});
};
